import React from 'react';
import Responsive from 'react-responsive';

const Desktop = ({ children }) => <Responsive minWidth={769} children={children} />;
const Mobile = ({ children }) => <Responsive maxWidth={768} children={children} />;
const Default = ({ children }) => <Responsive minWidth={769} children={children} />;

export default {
	Desktop,
	Mobile,
	Default
};


// WEBPACK FOOTER //
// ./src/components/responsive/index.js